<template>
  <div class="plan-style">
    <a
      v-if="       
        $store.state.liveMode &&
        props.date !== '' &&
        props.date !== null &&
        new Date(`${props.date.replace(/-/g, '/')} EST`).getTime() > new Date().getTime()
      "
      :class="{ tall, short, first, last }"
      @mouseover="active = true"
      @mouseout="active = false"
    >
      <PlanStyleInfo
        :active="active"
        :tall="tall"
        :trailingTitle="trailingTitle"
        :leadingTitle="leadingTitle"
        :short="short"
        :cta="cta"
        :title="title"
        :description="description"
        :image="image"
      />
    </a>
    <component
      v-else-if="to !== null"
      :is="to.includes('https') ? 'a' : 'router-link'"
      :to="to.includes('https') ? null : { name: to }"
      :target="to.includes('https') ? '_blank' : null"
      :href="to.includes('https') ? to : null"
      :class="{ tall, short, first, last }"
      @mouseover="active = true"
      @mouseout="active = false"
    >
      <PlanStyleInfo
        :active="active"
        :trailingTitle="trailingTitle"
        :leadingTitle="leadingTitle"
        :tall="tall"
        :short="short"
        :cta="cta"
        :title="title"
        :description="description"
        :image="image"
      />
    </component>
    <div v-if="props.date !== '' && props.date !== null" class="date">
      
    </div>
  </div>
</template>

<script setup>
import PlanStyleInfo from "@/components/PlanStyleInfo";
//import { format } from "date-fns";
import { ref } from "vue";
const props = defineProps({
  tall: Boolean,
  short: Boolean,
  first: Boolean,
  last: Boolean,
  title: String,
  date: {
    type: String,
    default: "",
  },
  trailingTitle: {
    default: "",
    type: String,
  },
  leadingTitle: {
    default: "",
    type: String,
  },
  to: String,
  cta: String,
  description: String,
  image: String,
});

const active = ref(false);
</script>

<style lang="scss" scoped>
.plan-style {
  position: relative;
  &:hover {
    a,
    button {
      box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.2);
    }
    .date {
      opacity: 0;
    }
    :deep() .description {
      transition: all 0.5s 0.1s, height 0.5s 0s;
      transform: scale(1) translateY(0);
      opacity: 1;
    }
  }
}
.date {
  padding: 13px 26px;
  font-family: "United Sans Cd Hv";
  font-weight: 900;
  font-size: 1rem;
  line-height: 0.94;
  position: absolute;
  right: 0;
  bottom:0;
  @media (min-width: 400px) {
    bottom: unset;
    right: 16px;
    top: 65%;
  }
  background: #0076b6;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  transition: all 0.2s;
  pointer-events: none;
  &:before {
    content: "";
    position: absolute;
    right: 0;
    bottom: -5px;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #004469;
    transform: rotateZ(135deg);
  }
  &:after {
    content: "";
    position: absolute;
    left: 29px;
    top: 12px;
    width: 0;
    height: 0;
    border-left: 29px solid transparent;
    border-right: 29px solid transparent;
    border-top: 29px solid #0076b6;
    transform: translateX(-100%) rotateZ(315deg);
    transform-origin: center bottom;
  }
}
.short:deep() h2 {
  font-size: 2.25rem;
  font-size: 2rem;
  div {
    vertical-align: middle;
    line-height: 1;
    text-transform: uppercase;
    color: #54585a;
    span {
      display: inline-block;
    }
  }
  span {
    white-space: nowrap;
    display: block;
    color: #0076b6;
    font-size: 1em;
    line-height: 1;
    text-shadow: 0px 3px 0px rgba(0, 0, 0, 0.15);
  }
}
.tall:deep() h2 {
  font-family: "United Sans Cd Hv";
  font-weight: 900;
  div {
    display: inline-block;
    color: #0076b6;
    text-shadow: 0px 3px 0px rgba(0, 0, 0, 0.15);
    font-size: 2.25rem;
    line-height: 1;
    text-transform: uppercase;
    :deep() span {
      display: block;
    }
  }
  div,
  img {
    vertical-align: middle;
  }
}
a {
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  flex-direction: column;
  background-color: #fff;
  color: #0076b6;
  text-transform: uppercase;
  font-weight: bold;
  position: relative;
  user-select: none;
  &:before {
    content: "";
    background-image: url("~@/assets/images/grunge.png");
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.1;
    pointer-events: none;
  }
  &.short {
    flex-direction: row;
    align-items: center;
    aspect-ratio: 2.87;    
    &:not(.first, .last){
      width:calc(100% - 20px);
    }    
    :deep() {
      .image {
        height: 100%;
        aspect-ratio: 1;
      }
      .info {
        width: 65%;
      }
    }
  }
  @media (min-width: 400px) {
    &.first {
      clip-path: url(#shortPlanTop);
      right: 4%;
      :deep() .image {
        margin-right: -23px;
      }
    }
    &.last {
      clip-path: url(#shortPlan);
    }
    &.tall {
      clip-path: url(#tallPlan);
      aspect-ratio: 1.36;
    }
  }
  @media (hover: hover) {
    &:hover {
      &:deep() {
        .description {
          transition: all 0.5s 0.1s, height 0.5s 0s;
          transform: scale(1) translateY(0);
          opacity: 1;
        }
        .arrow {
          transform: translateX(5px) scale(1.25);
        }
      }
    }
  }
}
</style>